const USERS = {
  ROW: "ردیف",
  USERS_LIST_TITLE: "کاربران آنلاین",
  A11Y: "دسترسی ها",
  USER: "کاربر",
  PAGE: "در صفحه",
  CHAT: "چت",
  CHATTING_WITH: "در حال مکالمه",
  START_CHAT: "آغاز گفتگو",
  START: "آغاز",
  CONVS_LIST: "مکالمات",
  FORM_INFO: "فرم",
  ROADMAP: "نقشه راه",
  SEARCH_IN_USERS: "جستجو در بین کاربران",
};

export default USERS;
